<template>
  <base-modal :title="title" :icon="icono" style="max-width: 800px; width: 100%;">

    <template #default>
      <!-- Si el consumidor pone contenido, reemplaza al render de `message`. -->
      <slot>
        <div class="d-flex align-center py-4 px-2">
          <v-icon :color="colorIcono" x-large class="mr-4">
            {{ icono }}
          </v-icon>
          <span class="text-body-1 grey--text text--darken-3 font-weight-medium">
            {{ message }}
          </span>
        </div>
      </slot>
    </template>

    <template #actions>
      <div class="d-flex w-100 justify-end pa-4">
        <!-- `textoCancelar` vacío oculta el botón: es lo que permite un modal
             terminal, donde la única salida posible es la acción primaria. -->
        <v-btn
          v-if="textoCancelar"
          rounded
          outlined
          color="#002245"
          class="mr-3 px-6"
          :disabled="cargando"
          @click="$emit('cancel')"
        >
          {{ textoCancelar }}
          <v-icon right size="20">mdi-cancel</v-icon>
        </v-btn>

        <v-btn
          rounded
          depressed
          :class="esColorPorDefecto ? 'bg--primary px-6' : 'px-6'"
          :color="esColorPorDefecto ? undefined : colorConfirmar"
          :dark="!esColorPorDefecto && !cargando"
          :loading="cargando"
          :disabled="cargando"
          @click="$emit('confirm')"
        >
          {{ textoConfirmar }}
          <v-icon right dark size="20">{{ iconoConfirmar }}</v-icon>
        </v-btn>
      </div>
    </template>

  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal.vue';

/**
 * Confirmación genérica.
 *
 * Todas las props agregadas tienen como valor por defecto el comportamiento
 * anterior (CANCELAR / CONFIRMAR, color primario, ícono de alerta, sin spinner),
 * así que los usos existentes —CatalogoTable.vue lo llama solo con `title` y
 * `message`— siguen viéndose y comportándose igual.
 */
export default {
  name: 'SeguroModal',

  components: {
    BaseModal,
  },

  props: {
    title: {
      type: String,
      default: '¿Está seguro de realizar esta acción?'
    },
    message: {
      type: String,
      default: 'Una vez realizada esta acción no podrá deshacerse.'
    },
    // Nueva prop para controlar el ancho desde afuera
    width: {
      type: [String, Number],
      default: '450' // Tamaño compacto por defecto
    },
    textoConfirmar: { type: String, default: 'CONFIRMAR' },
    /** Vacío ⇒ no se renderiza el botón (modal terminal). */
    textoCancelar: { type: String, default: 'CANCELAR' },
    /** Para acciones destructivas: 'error'. */
    colorConfirmar: { type: String, default: '#002245' },
    icono: { type: String, default: 'mdi-alert-circle-outline' },
    iconoConfirmar: { type: String, default: 'mdi-check-circle' },
    /** Spinner en el primario y ambos botones deshabilitados. */
    cargando: { type: Boolean, default: false },
  },

  computed: {
    // La clase `bg--primary` del proyecto ya trae fondo y color de texto; solo se
    // reemplaza por `color` cuando el consumidor pide otro color.
    esColorPorDefecto() {
      return this.colorConfirmar === '#002245';
    },
    colorIcono() {
      return this.colorConfirmar === 'error' ? 'error' : 'warning';
    },
  },

  emits: ['confirm', 'cancel'],
};
</script>
